import React, { useState, useEffect, useContext } from 'react';
import { Link, useParams } from 'react-router-dom';
import Icon3 from "../../assest/images/Icon3.png";
import Icon9 from "../../assest/images/Icon9.png";
import Image from '../common/image';
import x from '../../assest/images/x.png';
import config from "../../envconfig";

import { UserContext } from '../common/UserContext';
import { IoCaretDownOutline, IoCaretUpOutline } from 'react-icons/io5';

const SCPConfigList = () => {
  const [groupCompanies, setGroupCompanies] = useState([]);
  const [popupData, setPopupData] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  // const { UM_GroupId, UM_CompanyGrpID, selectedScpId, UM_CompanyID, UM_UserId, UM_UserCode, UM_DefaultSCPId } = useParams();
  const { UM_GroupId, UM_CompanyGrpID, selectedScpId, UM_CompanyID, UM_UserId, UM_UserCode, UM_DefaultSCPId } = useContext(UserContext);

  const [popupTitle, setPopupTitle] = useState('');


  useEffect(() => {
    sessionStorage.setItem('UM_GroupId', UM_GroupId);
    sessionStorage.setItem('UM_CompanyGrpID', UM_CompanyGrpID);
    sessionStorage.setItem('UM_DefaultSCPId', UM_DefaultSCPId);
    sessionStorage.setItem('UM_CompanyID', UM_CompanyID);
    sessionStorage.setItem('UM_UserId', UM_UserId);
    sessionStorage.setItem('UM_UserCode', UM_UserCode);

    sessionStorage.setItem('selectedScpId', selectedScpId);

  }, [UM_GroupId, UM_CompanyGrpID, UM_DefaultSCPId, UM_CompanyID, UM_UserId, UM_UserCode, selectedScpId]);
  useEffect(() => {
    fetchGroupCompanies();
  }, []);

  useEffect(() => {
    setCurrentPage(1); // Reset to page 1 when searchQuery changes
  }, [searchQuery]);

  const logAction = async (action, isError = false) => {
    console.log(`${isError ? '[ERROR] ' : ''}${action}`);
    try {
      const response = await fetch(`${config.API_URL}/api/log`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ module: "SCP-Configuration", action, userCode: UM_UserCode, isError }),
      });

      if (!response.ok) {
        throw new Error('Failed to log action');
      }
    } catch (error) {
      console.error('Error logging action:', error);
    }
  };

  const fetchGroupCompanies = async () => {
    try {
      const response = await fetch(`${config.API_URL}/scpconfig/list`);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const data = await response.json();
      logAction("fetchGroupCompanies():SCP-Configuration List page accessed")
      setGroupCompanies(data.data);
    } catch (error) {
      console.error('Error fetching Group Companies:', error);
      logAction('fetchGroupCompanies():Error occured showing SCP_Configuration List Page', true);
    }
  };

  const fetchPopupData = async (companyId, companyName) => {
    try {
      const response = await fetch(`${config.API_URL}/scpconfig/popup?company=${encodeURIComponent(companyId)}`); // Include UM_UserCode
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const data = await response.json();
      setPopupData(data.data);
      setShowPopup(true);
      setPopupTitle(`SCP Configuration for Company Group : ${companyName}`);
      logAction(`fetchPopupData():Pop up screen is opened for companyGroupName ${companyId}`)
    } catch (error) {
      console.error('Error fetching Popup data:', error);
      logAction(`fetchPopupData():Error occured showing Pop up screen for companyGroupName ${companyId}`, true)
    }
  };
  const closePopup = () => {
    setShowPopup(false);
    setPopupData([]);
    logAction("closePopup():Pop up screen is closed");
  };

  const handleEditClick = (company) => {
    console.log(`Editing company: ${company}`);
    logAction(`Starting edit configuration for ${company} company group name`);
  };

  // Filter companies based on search query
  const filteredCompanies = groupCompanies.filter((company) =>
    company.CGM_CompanyGroupName.toLowerCase().includes(searchQuery.toLowerCase())
  );

  // Logic for pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredCompanies.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const [isSelectOpen, setIsSelectOpen] = useState(false);
  const handleSelectOpen = (selectName) => {
    setIsSelectOpen(selectName);
    // logAction(`Select opened: ${selectName}`);
  };

  const handleSelectClose = () => {
    setIsSelectOpen(null);
    // logAction("Select closed");
  };
  return (
    <>

      <div className='main_container'>
        <h1 className='formHeading'>SCP Configuration
          {/* - <span className='display'>Display Screen</span> */}
        </h1>
        <div className="filter-container">
          <div className='select-container_list'>
            <select
              className='select-box_list'
              disabled
              style={{
                backgroundColor: '#f2f2f2',
                color: '#6c757d',
              }}
            >
              <option value="Company Group Name">Company Group Name</option>
            </select>
          </div>
          <input
            type="text"
            className='search-input searchbar'
            placeholder="Search"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>


        <>
          <div className="ptable-wrapper">
            <table className="ptableClass">
              <thead className="">
                <tr>
                  <th>Sr. No.</th>
                  <th>Company Group  Name</th>
                  <th>Configuration</th>
                  <th>Action</th>
                </tr>
              </thead>
              {filteredCompanies.length === 0 ? (
                <tbody >
                  <tr>
                    <td colSpan="4">No Records Found</td> {/* Set colSpan to match the number of columns */}
                  </tr>
                </tbody>
              ) : (
                <tbody>
                  {currentItems.map((company, index) => (
                    <tr key={index}>
                      <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                      <td>{company.CGM_CompanyGroupName}</td>
                      <td>
                        <img
                          src={Icon9}
                          alt="Pool"
                          className="pool-image"
                          title='Details'
                          onClick={() => fetchPopupData(company.CGM_ID, company.CGM_CompanyGroupName)}
                        />
                      </td>
                      <td>
                        <Link to={`/scpconfigedit/${company.CGM_ID}/${encodeURIComponent(company.CGM_CompanyGroupName)}`}>
                          <img
                            src={Icon3}
                            alt="Edit"
                            title='Edit'
                            className="edit-image"
                            onClick={() => handleEditClick(company)}
                          />
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              )}
            </table>
          </div>
          <ul className="pagination">
            {/* First Page Button */}
            <li className={currentPage === 1 || filteredCompanies.length === 0 ? "page-item disabled" : "page-item"}>
              <button className="page-linkd" onClick={() => paginate(1)}>First</button>
            </li>

            {/* Previous Page Button */}
            <li className={currentPage === 1 || filteredCompanies.length === 0 ? "page-item disabled" : "page-item"}>
              <button className="page-linkd" onClick={() => paginate(currentPage - 1)}>Previous</button>
            </li>

            {/* Page Numbers */}
            {Array.from({ length: Math.ceil(filteredCompanies.length / itemsPerPage) }, (_, index) => (
              <li key={index} className={currentPage === index + 1 ? "page-item active" : "page-item"}>
                <button className="page-linkd" onClick={() => paginate(index + 1)}>{index + 1}</button>
              </li>
            ))}

            {/* Next Page Button */}
            <li className={currentPage === Math.ceil(filteredCompanies.length / itemsPerPage) || filteredCompanies.length === 0 ? "page-item disabled" : "page-item"}>
              <button className="page-linkd" onClick={() => paginate(currentPage + 1)}>Next</button>
            </li>

            {/* Last Page Button */}
            <li className={currentPage === Math.ceil(filteredCompanies.length / itemsPerPage) || filteredCompanies.length === 0 ? "page-item disabled" : "page-item"}>
              <button className="page-linkd" onClick={() => paginate(Math.ceil(filteredCompanies.length / itemsPerPage))}>Last</button>
            </li>
          </ul>

        </>


        {showPopup && (
          <>
            <div className="popup_overlay">
              <div className="popup">
                <div>  <Link onClick={closePopup} > <Image src={x} alt="x" className="x" /></Link>
                </div>
                <h1 >{popupTitle}</h1>
                <table className="tableClass">
                  <thead>
                    <tr>
                      <th>SCP Level No</th>
                      <th>SCP Level Name</th>
                      <th>Allow Multiple Party Outward</th>
                      <th>Allow Same Level Multiple Party Outward</th>
                    </tr>
                  </thead>
                  <tbody>
                    {popupData.map((row, index) => (
                      <tr key={index}>
                        <td>{row.SCP_LevelNo}</td>
                        <td>{row.SCP_LevelName}</td>
                        <td>{row.SCP_AllowMutliplePartyOutward === 1 ? 'Yes' : 'No'}</td>
                        <td>{row.SCP_AllowMutliplePartySameLevelOutward === 1 ? 'Yes' : 'No'}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </>
        )}

      </div>
      <Link to={`/dashboard/scpconfig`}>
        <button type="button" className="back_btn">
          BACK
        </button>
      </Link>
    </>
  );
};

export default SCPConfigList;